import { useState } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

import { getAllDetails } from '../../service/ApiService';
import { TAX_LIST } from '../../config/ApiConstant';
import CommonTaxFileList from './CommonTaxFileList';

const UserTaxFileList = () => {
    const navigate = useNavigate();

    // tax payer selected date key
    const TAX_LIST_DATE_KEY = 'taxpayer_selected_date';
    const today = new Date();

    const getInitialDate = () => {
        const saved = localStorage.getItem(TAX_LIST_DATE_KEY);
        return saved ? moment(saved, 'YYYY-MM-DD').toDate() : today;
    };

    const [dates, setDates] = useState<Date>(getInitialDate());

    const fetchData = async (searchStr?: string) => {
        let url = TAX_LIST + `?date=${moment(dates).format('YYYY-MM-DD')}`;
        if (searchStr) {
            url += `&search=${searchStr}`;
        }
        const response = await getAllDetails(url);
        return response;
    };

    const handleDateChange = (e: any) => {
        const val = e.value;
        setDates(val);
        if (val) {
            localStorage.setItem(TAX_LIST_DATE_KEY, moment(val).format('YYYY-MM-DD'));
        }
    };

    const handlePreviousDate = () => {
        const newDate = moment(dates).subtract(1, 'day').toDate();
        setDates(newDate);
        localStorage.setItem(TAX_LIST_DATE_KEY, moment(newDate).format('YYYY-MM-DD'));
    };

    const handleNextDate = () => {
        const newDate = moment(dates).add(1, 'day').toDate();
        setDates(newDate);
        localStorage.setItem(TAX_LIST_DATE_KEY, moment(newDate).format('YYYY-MM-DD'));
    };

    const extraToolbarLeft = (
        <Button
            className="common-primary-button"
            onClick={() => navigate('/taxlist/add-tax-payer-manually')}
        >
            Add TaxPayer Manually
        </Button>
    );

    const extraToolbarRight = (
        <div className="flex align-items-center gap-2">
            <Button
                icon="pi pi-chevron-left"
                className="common-primary-button"
                onClick={handlePreviousDate}
                aria-label="Previous Day"
            />
            <Calendar
                value={dates}
                onChange={handleDateChange}
                readOnlyInput
                dateFormat="dd/mm/yy"
                placeholder="Select Date"
                showIcon
                className="w-12rem"
            />
            <Button
                icon="pi pi-chevron-right"
                className="common-primary-button"
                onClick={handleNextDate}
                aria-label="Next Day"
            />
        </div>
    );

    return (
        <CommonTaxFileList
            fetchData={fetchData}
            pageTitle="Taxpayer"
            breadcrumbMenu="Taxpayer List"
            storagePrefix="taxList"
            emptyMessage="No tax list found."
            extraToolbarLeft={extraToolbarLeft}
            extraToolbarRight={extraToolbarRight}
            refreshDependencies={[dates]}
        />
    );
};

export default UserTaxFileList;
